import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  assetId: string;
  name: string;
  linkId: number;
};

const [useUpdateAssetDirectLink, updateAssetDirectLink] = createAsyncAction(
  "assets/updateDirectLink",
  async ({ assetId, name, linkId }: Args) => {
    const res = await API.call<{ directLink: number }>({
      endpoint: `assets/${assetId}/direct_links/${linkId}`,
      method: "PUT",
      data: { name },
    });
    return { ...res, result: res.result.directLink };
  }
);

export default useUpdateAssetDirectLink;
export { updateAssetDirectLink };
